import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { EditCampaignSuccess } from '../actions/campaign-search.actions';
import { CampaignSelectionTargetChanged } from '../actions/wizard-setup.actions';
import {
  apifonSMSAccountChange,
  apifonSMSAccountsSuccess,
  apifonViberAccountChange,
  apifonViberAccountsSuccess,
  aws_sesAccountsSuccess,
  aws_sesSendersSuccess,
  contactPigeonAccountsSuccess,
  enboxAccountsSuccess,
  fetchAdhocListDataSuccess,
  fetchPushNotificationAccountsFailure,
  fetchPushNotificationAccountsInit,
  fetchPushNotificationAccountsSuccess,
  FilterCouponSets,
  getCouponActionsSuccess,
  getCouponSetsSuccess,
  getFlowsSuccess,
  getPointSourcesSuccess,
  getTagsSuccess,
  HelpTextChanged,
  loadAttributeCodesSuccess,
  mailchimpAccountsSuccess,
  mstatViberAccountChange,
  mstatViberAccountsSuccess,
  nexusAccountChange,
  nexusAccountsSuccess,
  omniViberAccountChange,
  omniViberAccountsSuccess,
  QC_Message_AppAccountsSuccess,
  showAdhocList,
  testCampaignAdhocListItemChanged,
  ToggleActionCategory,
  ToggleCouponAction,
  toggleInAppLanguage,
  toggleLanguage,
  updateCampaignAdHocListAction,
  updateCampaignAdhocPoints,
  updateCampaignAttribute,
  updateCampaignEmail,
  updateCampaignFlow,
  updateCampaignReport,
  updateCampaignSMS,
  updateCampaignTag,
  updateCampaignViber,
  UpdateCoupon,
  UpdateCustomCouponAction,
  updateInAppMessageConfig,
  updatePushNotificationConfig,
  uploadFileSuccess,
  uploadInAppImage,
  uploadInAppImageFailure,
  uploadInAppImageSuccess,
  uploadViberImage,
  uploadViberImageFailure,
  uploadViberImageSuccess,
} from '../actions/wizard-what.actions';
import { ResetWizard } from '../actions/wizard.actions';
import { CampaignAttribute } from '../models/campaign-add-attributes.interface';
import { CampaignEmail } from '../models/campaign-email.interface';
import { CampaignActionType, WizardWhatState } from '../models/wizard.model';

const initialState: WizardWhatState = {
  helpTextStatus: false,
  selectedActionTypes: [],
  actionConfigs: {},
  selectedSmsLanguages: [],
  selectedViberLanguages: [],
  selectedInAppLanguages: [],
  nexusAccounts: [],
  campaignSms: {
    dateFromPlaceHolder: '',
    dateUntilPlaceHolder: '',
    integrationCode: '',
    nexusAccountId: null,
    smsMessage: null,
    smsMessageCode: '',
    vendor: 'APIFON',
    attributePlaceholders: {
      memberAttributes: [],
      customerAttributes: [],
    },
    showSmsAdhocList: false,
  },
  campaignEmail: {
    emailLocaleConfigs: [],
    enBox: false,
    sendEnBoxCampaign: false,
    enBoxAccountName: null,
    enBoxABConfig: null,
    mailChimp: false,
    sendMailChimpCampaign: false,
    mailChimpAccountName: null,
    mailChimpABConfig: null,
    contactPigeon: false,
    sendContactPigeonCampaign: false,
    contactPigeonAccountName: null,
    ses: false,
    sesAccountName: null,
  },
  campaignViber: {
    actionTracking: false,
    actionUrl: '',
    apifon: false,
    mstat: false,
    mstatV2: false,
    attributePlaceholders: {
      memberAttributes: [],
      customerAttributes: [],
    },
    caption: '',
    dateFromPlaceHolder: '',
    dateUntilPlaceHolder: '',
    fallBackSms: {
      dateFromPlaceHolder: '',
      dateUntilPlaceHolder: '',
      smsMessage: null,
      validityPeriod: 35,
      attributePlaceholders: {
        memberAttributes: [],
        customerAttributes: [],
      },
      showFallbackSmsAdhocList: false,
    },
    fallBackSmsRequired: false,
    imageUrl: '',
    integrationCode: '',
    validityPeriod: 5,
    viberConfigurationId: '',
    viberMessage: null,
    isUploadingViberImage: false,
    viberImageUploadError: false,
    showViberAdhocList: false,
  },
  campaignPushNotification: {
    vendor: 'SEAMLESS',
    accountName: null,
    title: '',
    notificationMessage: '',
    deepLinkUrl: '',
    redirectUrl: '',
    userDefinedDataObj: '',
    withCoupon: false,
  },
  campaignInAppMessage: {
    vendor: 'QC_MESSAGE_APP',
    accountName: null,
    dateFromPlaceHolder: null,
    dateUntilPlaceHolder: null,
    activeFrom: { days: null, months: null, date: null },
    activeUntil: { days: null, months: null, date: null },
    title: {},
    inAppMessage: {},
    imageUrl: {},
    linkTitle: {},
    linkUrl: {},
    attributePlaceholders: {
      memberAttributes: [],
      customerAttributes: [],
    },
    isUploadingImage: {},
    imageUploadError: {},
  },
  campaignCoupon: {
    couponSetId: null,
    expirationType: 'durDays',
    couponDurationDays: null,
    couponValidFrom: null,
    couponValidUntil: null,
    useAvailableCoupon: false,
    useAvailableCouponForMember: false,
    couponReminder: false,
    customCouponAction: null,
  },
  campaignAdHocPoint: {
    loyaltyPointSourceId: null,
    adHocPoints: '',
    adHocPointsRemarks: '',
    days: null,
    months: null,
    pointExpirationDate: '',
    expirationType: 'daysMonths',
  },
  campaignAdHocListAction: {
    listName: null,
    updateList: false,
  },
  campaignReport: false,
  campaignTag: {
    tagIdList: [],
    startDate: '',
    endDate: '',
    addStartDaysFromExecutionDate: null,
    addEndDaysFromExecutionDate: null,
    addStartMonthsFromExecutionDate: null,
    addEndMonthsFromExecutionDate: null,
    startDurationType: 'date',
    endDurationType: 'none',
  },
  campaignAttribute: {
    customerAttributes: [],
    memberAttributes: [],
  },
  campaignEmarsysConfig: null,
  campaignFlow: { flowId: null },
  apifonSMSAccounts: [],
  apifonViberAccounts: [],
  mstatViberAccounts: [],
  omniViberAccounts: [],
  mailChimpAccounts: [],
  enboxAccounts: [],
  contactPigeonAccounts: [],
  aws_sesAccounts: [],
  pushNotificationAccounts: [],
  inAppMessageAccounts: [],
  memberAttributeCodes: [],
  personAttributeCodes: [],
  senderEmailAddresses: [],
  senderNames: [],
  couponSets: [],
  couponSetFilter: '',
  couponActions: [],
  pointSources: [],
  tags: [],
  flows: [],
  adhocListData: [],
  selectedActionType: null,
  selectedTestViberCampaignAdhocList: null,
  selectedTestFallbackSmsCampaignAdhocList: null,
  selectedTestSmsCampaignAdhocList: null,
  enableViberActionButtons: false,
  enableFallbackSmsActionButtons: false,
  enableSmsActionButtons: false,
};

export const WizardWhatReducer = createReducer(
  initialState,
  on(HelpTextChanged, (state) => ({
    ...state,
    helpTextStatus: !state.helpTextStatus,
  })),
  on(ToggleActionCategory, (state, { actionType, isSelected }) => {
    const updatedTypes = isSelected
      ? [...state.selectedActionTypes, actionType]
      : state.selectedActionTypes.filter((type) => type !== actionType);

    let newState = {
      ...state,
      selectedActionTypes: updatedTypes,
    };

    if (!isSelected) {
      switch (actionType) {
        case 'COUPON':
          newState = { ...newState, campaignCoupon: { ...initialState.campaignCoupon } };
          break;
        case 'POINTS':
          newState = { ...newState, campaignAdHocPoint: { ...initialState.campaignAdHocPoint } };
          break;
        case 'LIST':
          newState = {
            ...newState,
            campaignAdHocListAction: { ...initialState.campaignAdHocListAction },
          };
          break;
        case 'TAG':
          newState = { ...newState, campaignTag: { ...initialState.campaignTag } };
          break;
        case 'FLOW':
          newState = { ...newState, campaignFlow: { ...initialState.campaignFlow } };
          break;
        case 'SMS':
          newState = { ...newState, campaignSms: { ...initialState.campaignSms } };
          break;
        case 'VIBER':
          newState = { ...newState, campaignViber: { ...initialState.campaignViber } };
          break;
        case 'EMAIL':
          newState = { ...newState, campaignEmail: { ...initialState.campaignEmail } };
          break;
        case 'PUSH_NOTIFICATION':
          newState = {
            ...newState,
            campaignPushNotification: { ...initialState.campaignPushNotification },
          };
          break;
        case 'IN_APP_MESSAGE':
          newState = {
            ...newState,
            campaignInAppMessage: { ...initialState.campaignInAppMessage },
          };
          break;
        case 'ATTRIBUTE':
          newState = { ...newState, campaignAttribute: { ...initialState.campaignAttribute } };
          break;
        case 'RECORD':
          newState = { ...newState, campaignReport: false };
          break;
      }
    }

    if (actionType === 'RECORD') {
      newState = {
        ...newState,
        campaignReport: isSelected,
      };
    }

    return newState;
  }),
  on(nexusAccountsSuccess, (state, { nexusAccounts }) => ({
    ...state,
    nexusAccounts,
  })),
  on(apifonSMSAccountsSuccess, (state, { apifonSMSAccounts }) => ({
    ...state,
    apifonSMSAccounts,
  })),
  on(apifonViberAccountsSuccess, (state, { apifonViberAccounts }) => ({
    ...state,
    apifonViberAccounts,
  })),
  on(mstatViberAccountsSuccess, (state, { mstatViberAccounts }) => ({
    ...state,
    mstatViberAccounts,
  })),
  on(omniViberAccountsSuccess, (state, { omniViberAccounts }) => ({
    ...state,
    omniViberAccounts,
  })),
  on(mailchimpAccountsSuccess, (state, { mailchimpAccounts }) => ({
    ...state,
    mailchimpAccounts,
  })),
  on(enboxAccountsSuccess, (state, { enboxAccounts }) => ({
    ...state,
    enboxAccounts,
  })),
  on(contactPigeonAccountsSuccess, (state, { contactPigeonAccounts }) => ({
    ...state,
    contactPigeonAccounts,
  })),
  on(aws_sesAccountsSuccess, (state, { aws_sesAccounts }) => ({
    ...state,
    aws_sesAccounts,
  })),
  on(QC_Message_AppAccountsSuccess, (state, { QC_Message_AppAccounts }) => ({
    ...state,
    inAppMessageAccounts: QC_Message_AppAccounts,
  })),
  on(apifonSMSAccountChange, (state, { apifonSMSAccount }) => ({
    ...state,
    campaignSms: {
      ...state.campaignSms,
      integrationCode: apifonSMSAccount,
    },
  })),
  on(apifonViberAccountChange, (state, { apifonViberAccount }) => ({
    ...state,
    campaignViber: {
      ...state.campaignViber,
      integrationCode: apifonViberAccount,
    },
  })),
  on(mstatViberAccountChange, (state, { mstatViberAccount }) => ({
    ...state,
    campaignViber: {
      ...state.campaignViber,
      integrationCode: mstatViberAccount,
    },
  })),
  on(omniViberAccountChange, (state, { omniViberAccount }) => ({
    ...state,
    campaignViber: {
      ...state.campaignViber,
      integrationCode: omniViberAccount,
    },
  })),
  on(nexusAccountChange, (state, { nexusAccount }) => ({
    ...state,
    campaignSms: {
      ...state.campaignSms,
      nexusAccountId: nexusAccount.nexusAccountId,
    },
  })),
  on(toggleLanguage, (state, { channel, language, isChecked, isSingleSelect }) => {
    if (channel === 'SMS' || channel === 'VIBER') {
      const currentArray =
        channel === 'SMS' ? state.selectedSmsLanguages : state.selectedViberLanguages;
      let updatedArray = [];

      if (isSingleSelect) {
        updatedArray = isChecked ? [language] : [];
      } else {
        updatedArray = isChecked
          ? [...currentArray, language]
          : currentArray.filter((l) => l !== language);
      }
      const pruneByLanguages = (dict: Record<string, any> | null | undefined) => {
        if (!dict) return dict ?? null;
        return updatedArray.reduce<Record<string, any>>((acc, lang) => {
          if (Object.prototype.hasOwnProperty.call(dict, lang)) {
            acc[lang] = dict[lang];
          }
          return acc;
        }, {});
      };

      if (channel === 'SMS') {
        return {
          ...state,
          selectedSmsLanguages: updatedArray,
          campaignSms: {
            ...state.campaignSms,
            smsMessage: pruneByLanguages(state.campaignSms?.smsMessage),
          },
        };
      }

      return {
        ...state,
        selectedViberLanguages: updatedArray,
        campaignViber: {
          ...state.campaignViber,
          viberMessage: pruneByLanguages(state.campaignViber?.viberMessage),
          fallBackSms: {
            ...state.campaignViber?.fallBackSms,
            smsMessage: pruneByLanguages(state.campaignViber?.fallBackSms?.smsMessage),
          },
        },
      };
    }
    if (channel === 'EMAIL') {
      const currentConfigs = state.campaignEmail?.emailLocaleConfigs || [];
      let updatedConfigs = [...currentConfigs];

      const newLocaleConfig = {
        languageCode: language,
        emailSubject: null,
        emailSenderAddress: null,
        emailSenderName: null,
        personalizedUrl: null,
        dateFrom: null,
        dateUntil: null,
        emailTemplatePath: null,
        emailTemplatePathAdvance: null,
      };

      if (isSingleSelect) {
        updatedConfigs = isChecked ? [newLocaleConfig] : [];
      } else {
        if (isChecked) {
          if (!updatedConfigs.some((config) => config.languageCode === language)) {
            updatedConfigs.push(newLocaleConfig);
          }
        } else {
          updatedConfigs = updatedConfigs.filter((config) => config.languageCode !== language);
        }
      }

      return {
        ...state,
        campaignEmail: {
          ...(state.campaignEmail || {}),
          emailLocaleConfigs: updatedConfigs,
        },
      };
    }

    return state;
  }),
  on(loadAttributeCodesSuccess, (state, { memberAttributeCodes, personAttributeCodes }) => ({
    ...state,
    memberAttributeCodes,
    personAttributeCodes,
  })),
  on(ResetWizard, (state) => ({
    ...initialState,
    memberAttributeCodes: state.memberAttributeCodes,
    personAttributeCodes: state.personAttributeCodes,
  })),
  on(CampaignSelectionTargetChanged, (state) => ({
    ...initialState,
    memberAttributeCodes: state.memberAttributeCodes,
    personAttributeCodes: state.personAttributeCodes,
  })),
  on(EditCampaignSuccess, (state, { campaign }) => {
    const campaignWhat = campaign.data.campaignWhat;

    if (!campaignWhat) return state;

    const selectedActionTypes: CampaignActionType[] = [];

    let selectedSmsLanguages: string[] = [];
    let selectedViberLanguages: string[] = [];
    let selectedInAppLanguages: string[] = [];

    let newCampaignSMS: typeof initialState.campaignSms = { ...state.campaignSms };
    let newCampaignViber: typeof initialState.campaignViber = { ...state.campaignViber };
    let newCampaignEmail: typeof initialState.campaignEmail = { ...state.campaignEmail };
    let newCampaignPushNotification: typeof initialState.campaignPushNotification = {
      ...state.campaignPushNotification,
    };
    let newCampaignInAppMessage: typeof initialState.campaignInAppMessage = {
      ...state.campaignInAppMessage,
    };
    let newCampaignCoupon: typeof initialState.campaignCoupon = { ...state.campaignCoupon };
    let newCampaignAdhocPoints: typeof initialState.campaignAdHocPoint = {
      ...state.campaignAdHocPoint,
    };
    let newCampaignAdhocListAction: typeof initialState.campaignAdHocListAction = {
      ...state.campaignAdHocListAction,
    };
    let newCampaignReport = false;
    let newCampaignTag: typeof initialState.campaignTag = { ...state.campaignTag };
    let newCampaignFlow = { ...initialState.campaignFlow };
    let newCampaignAttribute: typeof initialState.campaignAttribute = {
      ...state.campaignAttribute,
    };

    // --- SMS Mapping ---
    if (campaignWhat.campaignSms) {
      selectedActionTypes.push('SMS' as CampaignActionType);

      const smsData = campaignWhat.campaignSms;

      if (smsData.smsMessage) {
        selectedSmsLanguages = Object.keys(smsData.smsMessage);
      }

      newCampaignSMS = {
        dateFromPlaceHolder: smsData.dateFromPlaceHolder || '',
        dateUntilPlaceHolder: smsData.dateUntilPlaceHolder || '',
        integrationCode: smsData.integrationCode || '',
        nexusAccountId: smsData.nexusAccountId || null,
        smsMessage: smsData.smsMessage || null,
        smsMessageCode: smsData.smsMessageCode || '',
        vendor: smsData.nexusAccountId ? 'NEXUS' : 'APIFON',
        attributePlaceholders: smsData.attributePlaceholders || {
          memberAttributes: [],
          customerAttributes: [],
        },
      };
    }

    // --- Viber Mapping ---
    if (campaignWhat.campaignViber) {
      selectedActionTypes.push('VIBER' as CampaignActionType);
      const viberData = campaignWhat.campaignViber;
      const fallbackSmsOn = viberData.fallBackSmsRequired === true || !!viberData.fallBackSms;
      if (fallbackSmsOn) {
        selectedActionTypes.push('VIBER_FALLBACK_SMS' as CampaignActionType);
      }

      if (viberData.viberMessage) {
        selectedViberLanguages = Object.keys(viberData.viberMessage);
      }

      newCampaignViber = {
        actionTracking: viberData.actionTracking || false,
        actionUrl: viberData.actionUrl || '',
        apifon: viberData.apifon || false,
        mstat: viberData.mstat || false,
        mstatV2: viberData.mstatV2 || false,
        attributePlaceholders: viberData.attributePlaceholders || {
          memberAttributes: [],
          customerAttributes: [],
        },
        caption: viberData.caption || '',
        dateFromPlaceHolder: viberData.dateFromPlaceHolder || '',
        dateUntilPlaceHolder: viberData.dateUntilPlaceHolder || '',
        fallBackSmsRequired: fallbackSmsOn,
        fallBackSms: viberData.fallBackSms || {
          dateFromPlaceHolder: '',
          dateUntilPlaceHolder: '',
          smsMessage: null,
          validityPeriod: 0,
          attributePlaceholders: { memberAttributes: [], customerAttributes: [] },
        },
        imageUrl: viberData.imageUrl || '',
        integrationCode: viberData.integrationCode || '',
        validityPeriod: viberData.validityPeriod || 0,
        viberConfigurationId: viberData.viberConfigurationId || '',
        viberMessage: viberData.viberMessage || null,
        isUploadingViberImage: false,
        viberImageUploadError: false,
      };
    }

    // --- Email Mapping ---
    if (campaignWhat.campaignEmail) {
      selectedActionTypes.push('EMAIL' as CampaignActionType);
      const emailData = campaignWhat.campaignEmail;

      newCampaignEmail = {
        mailChimp: emailData.mailChimp || false,
        sendMailChimpCampaign: emailData.sendMailChimpCampaign || false,
        mailChimpAccountName: emailData.mailChimpAccountName || null,
        mailChimpABConfig: emailData.mailChimpABConfig || null,

        enBox: emailData.enBox || false,
        sendEnBoxCampaign: emailData.sendEnBoxCampaign || false,
        enBoxSubscribersListId: emailData.enBoxSubscribersListId || null,
        enBoxAccountName: emailData.enBoxAccountName || null,
        enBoxABConfig: emailData.enBoxABConfig || null,

        contactPigeon: emailData.contactPigeon || false,
        sendContactPigeonCampaign: emailData.sendContactPigeonCampaign || false,
        contactPigeonAccountName: emailData.contactPigeonAccountName || null,

        ses: emailData.ses || false,
        sesAccountName: emailData.sesAccountName || null,

        attributePlaceholders: emailData.attributePlaceholders || null,
        emailLocaleConfigs: emailData.emailLocaleConfigs || [],
      };
    }

    // --- Push Notification Mapping ---
    if (campaignWhat.campaignPushNotification) {
      selectedActionTypes.push('PUSH_NOTIFICATION' as CampaignActionType);
      const pushData = campaignWhat.campaignPushNotification;

      newCampaignPushNotification = {
        vendor: pushData.vendor || 'SEAMLESS',
        accountName: pushData.accountName || null,
        title: pushData.title || '',
        notificationMessage: pushData.notificationMessage || '',
        deepLinkUrl: pushData.deepLinkUrl || '',
        redirectUrl: pushData.redirectUrl || '',
        userDefinedDataObj: pushData.userDefinedDataObj || '',
        withCoupon: pushData.withCoupon || false,
      };
    }

    // --- In-App Message Mapping ---
    if (campaignWhat.campaignInAppMessage) {
      selectedActionTypes.push('IN_APP_MESSAGE' as CampaignActionType);
      const inAppData = campaignWhat.campaignInAppMessage;

      if (inAppData.inAppMessage) {
        selectedInAppLanguages = Object.keys(inAppData.inAppMessage);
      }

      newCampaignInAppMessage = {
        accountName: inAppData.accountName || null,
        activeFrom: {
          days: inAppData.activeFrom?.days || null,
          months: inAppData.activeFrom?.months || null,
          date: inAppData.activeFrom?.date
            ? new Date(inAppData.activeFrom.date).toISOString()
            : null,
        },
        activeUntil: {
          days: inAppData.activeUntil?.days || null,
          months: inAppData.activeUntil?.months || null,
          date: inAppData.activeUntil?.date
            ? new Date(inAppData.activeUntil.date).toISOString()
            : null,
        },
        attributePlaceholders: inAppData.attributePlaceholders || {
          memberAttributes: [],
          customerAttributes: [],
        },
        dateFromPlaceHolder: inAppData.dateFromPlaceHolder || null,
        dateUntilPlaceHolder: inAppData.dateUntilPlaceHolder || null,
        inAppMessage: inAppData.inAppMessage || {},
        title: inAppData.title || {},
        imageUrl: inAppData.imageUrl || {},
        linkTitle: inAppData.linkTitle || {},
        linkUrl: inAppData.linkUrl || {},
        isUploadingImage: {},
        imageUploadError: {},
      };
    }

    // --- Coupon Mapping ---
    if (campaignWhat.campaignCoupon) {
      if (!selectedActionTypes.includes('COUPON' as CampaignActionType)) {
        selectedActionTypes.push('COUPON' as CampaignActionType);
      }

      const couponData = campaignWhat.campaignCoupon;

      let derivedExpirationType: 'durDays' | 'valUnFr' | 'none' = 'none';
      if (couponData.couponDurationDays !== null && couponData.couponDurationDays !== undefined) {
        derivedExpirationType = 'durDays';
      } else if (couponData.couponValidFrom || couponData.couponValidUntil) {
        derivedExpirationType = 'valUnFr';
      }

      newCampaignCoupon = {
        couponSetId: couponData.couponSetId || null,
        expirationType: derivedExpirationType,
        couponDurationDays: couponData.couponDurationDays || null,
        couponValidFrom: couponData.couponValidFrom
          ? new Date(couponData.couponValidFrom).toISOString()
          : null,
        couponValidUntil: couponData.couponValidUntil
          ? new Date(couponData.couponValidUntil).toISOString()
          : null,
        useAvailableCoupon: couponData.useAvailableCoupon || false,
        useAvailableCouponForMember: couponData.useAvailableCouponForMember || false,
        couponReminder: couponData.couponReminder || false,
        customCouponAction: couponData.customCouponAction
          ? {
              type: couponData.customCouponAction.type || null,
              customGenerationKey: couponData.customCouponAction.customGenerationKey || null,
            }
          : null,
      };
    }

    // --- AdHoc Points Mapping ---
    if (campaignWhat.campaignAdHocPoint) {
      if (!selectedActionTypes.includes('POINTS' as CampaignActionType)) {
        selectedActionTypes.push('POINTS' as CampaignActionType);
      }

      const pointData = campaignWhat.campaignAdHocPoint;

      let derivedPointExpirationType: 'daysMonths' | 'date' = 'daysMonths';
      if (pointData.pointExpirationDate) {
        derivedPointExpirationType = 'date';
      }

      newCampaignAdhocPoints = {
        loyaltyPointSourceId: pointData.loyaltyPointSourceId || null,
        adHocPoints: pointData.adHocPoints || '',
        adHocPointsRemarks: pointData.adHocPointsRemarks || '',
        expirationType: derivedPointExpirationType,
        days: pointData.days || null,
        months: pointData.months || null,
        pointExpirationDate: pointData.pointExpirationDate
          ? new Date(pointData.pointExpirationDate).toISOString()
          : null,
      };
    }

    // --- AdHoc List Action Mapping ---
    if (campaignWhat.campaignAdHocListAction) {
      if (!selectedActionTypes.includes('LIST' as CampaignActionType)) {
        selectedActionTypes.push('LIST' as CampaignActionType);
      }
      const adhocListData = campaignWhat.campaignAdHocListAction;
      newCampaignAdhocListAction = {
        listName: adhocListData.listName || null,
        updateList: adhocListData.updateList || null,
      };
    }

    // --- Report ---
    if (campaignWhat.hasOwnProperty('campaignReport')) {
      if (campaignWhat.campaignReport === true) {
        if (!selectedActionTypes.includes('RECORD' as CampaignActionType)) {
          selectedActionTypes.push('RECORD' as CampaignActionType);
        }
        newCampaignReport = true;
      }
    }

    // --- Campaign Tag Mapping ---
    if (campaignWhat.campaignTag) {
      if (!selectedActionTypes.includes('TAG' as CampaignActionType)) {
        selectedActionTypes.push('TAG' as CampaignActionType);
      }

      const tagData = campaignWhat.campaignTag;

      let derivedStartDuration: 'daysMonths' | 'date' = 'date';
      if (tagData.startDate) {
        derivedStartDuration = 'date';
      } else if (
        (tagData.addStartDaysFromExecutionDate !== null &&
          tagData.addStartDaysFromExecutionDate !== undefined) ||
        (tagData.addStartMonthsFromExecutionDate !== null &&
          tagData.addStartMonthsFromExecutionDate !== undefined)
      ) {
        derivedStartDuration = 'daysMonths';
      }

      let derivedEndDuration: 'daysMonths' | 'date' | 'none' = 'none';
      if (tagData.endDate) {
        derivedEndDuration = 'date';
      } else if (
        (tagData.addEndDaysFromExecutionDate !== null &&
          tagData.addEndDaysFromExecutionDate !== undefined) ||
        (tagData.addEndMonthsFromExecutionDate !== null &&
          tagData.addEndMonthsFromExecutionDate !== undefined)
      ) {
        derivedEndDuration = 'daysMonths';
      }

      newCampaignTag = {
        tagIdList: tagData.tagIdList || [],
        startDurationType: derivedStartDuration,
        endDurationType: derivedEndDuration,

        startDate: tagData.startDate ? new Date(tagData.startDate).toISOString() : null,

        addStartDaysFromExecutionDate: tagData.addStartDaysFromExecutionDate ?? null,
        addStartMonthsFromExecutionDate: tagData.addStartMonthsFromExecutionDate ?? null,

        endDate: tagData.endDate ? new Date(tagData.endDate).toISOString() : null,

        addEndDaysFromExecutionDate: tagData.addEndDaysFromExecutionDate ?? null,
        addEndMonthsFromExecutionDate: tagData.addEndMonthsFromExecutionDate ?? null,
      };
    }

    // --- Campaign Trigger Flow Mapping ---
    if (campaignWhat.campaignFlow) {
      if (!selectedActionTypes.includes('FLOW' as CampaignActionType)) {
        selectedActionTypes.push('FLOW' as CampaignActionType);
      }

      newCampaignFlow = {
        flowId: campaignWhat.campaignFlow.flowId || null,
      };
    }

    // --- Campaign Attribute Mapping ---
    if (campaignWhat.campaignAttribute) {
      if (!selectedActionTypes.includes('ATTRIBUTE' as CampaignActionType)) {
        selectedActionTypes.push('ATTRIBUTE' as CampaignActionType);
      }

      const attributeData = campaignWhat.campaignAttribute;
      const emptyRow = {
        attributeType: null,
        attributeName: null,
        attributeValue: null,
        isAdded: false,
      };

      newCampaignAttribute = {
        customerAttributes: [
          ...(attributeData.customerAttributes || []).map((attr: any) => ({
            ...attr,
            isAdded: true,
          })),
          { ...emptyRow },
        ],
        memberAttributes: [
          ...(attributeData.memberAttributes || []).map((attr: any) => ({
            ...attr,
            isAdded: true,
          })),
          { ...emptyRow },
        ],
      };
    }

    return {
      ...state,
      selectedActionTypes,
      selectedSmsLanguages:
        selectedSmsLanguages.length > 0 ? selectedSmsLanguages : state.selectedSmsLanguages,
      selectedViberLanguages:
        selectedViberLanguages.length > 0 ? selectedViberLanguages : state.selectedViberLanguages,
      selectedInAppLanguages:
        selectedInAppLanguages.length > 0 ? selectedInAppLanguages : state.selectedInAppLanguages,
      campaignSms: newCampaignSMS,
      campaignViber: newCampaignViber,
      campaignEmail: newCampaignEmail,
      campaignPushNotification: newCampaignPushNotification,
      campaignInAppMessage: newCampaignInAppMessage,
      campaignCoupon: newCampaignCoupon,
      campaignAdHocPoint: newCampaignAdhocPoints,
      campaignAdHocListAction: newCampaignAdhocListAction,
      campaignReport: newCampaignReport,
      campaignTag: newCampaignTag,
      campaignFlow: newCampaignFlow,
      campaignAttribute: newCampaignAttribute,
    };
  }),
  on(uploadViberImage, (state) => ({
    ...state,
    campaignViber: {
      ...state.campaignViber,
      isUploadingViberImage: true,
      viberImageUploadError: false,
    },
  })),
  on(uploadViberImageSuccess, (state, { imageUrl }) => ({
    ...state,
    campaignViber: {
      ...state.campaignViber,
      imageUrl: imageUrl,
      isUploadingViberImage: false,
      viberImageUploadError: false,
    },
  })),
  on(uploadViberImageFailure, (state) => ({
    ...state,
    campaignViber: {
      ...state.campaignViber,
      isUploadingViberImage: false,
      viberImageUploadError: true,
    },
  })),
  on(uploadInAppImage, (state, { langCode }) => ({
    ...state,
    campaignInAppMessage: {
      ...state.campaignInAppMessage,
      isUploadingImage: {
        ...state.campaignInAppMessage.isUploadingImage,
        [langCode]: true,
      },
      imageUploadError: {
        ...state.campaignInAppMessage.imageUploadError,
        [langCode]: null,
      },
    },
  })),
  on(uploadInAppImageSuccess, (state, { imageUrl, langCode }) => ({
    ...state,
    campaignInAppMessage: {
      ...state.campaignInAppMessage,
      imageUrl: {
        ...state.campaignInAppMessage.imageUrl,
        [langCode]: imageUrl,
      },
      isUploadingImage: {
        ...state.campaignInAppMessage.isUploadingImage,
        [langCode]: false,
      },
    },
  })),
  on(uploadInAppImageFailure, (state, { error, langCode }) => ({
    ...state,
    campaignInAppMessage: {
      ...state.campaignInAppMessage,
      imageUploadError: {
        ...state.campaignInAppMessage.imageUploadError,
        [langCode]: error,
      },
      isUploadingImage: {
        ...state.campaignInAppMessage.isUploadingImage,
        [langCode]: false,
      },
    },
  })),
  on(uploadFileSuccess, (state, { fileUrl, languageCode }) => {
    const updatedConfigs =
      state.campaignEmail?.emailLocaleConfigs.map((config) => {
        if (config.languageCode === languageCode) {
          return {
            ...config,
            emailTemplatePath: fileUrl,
            emailTemplatePathAdvance: fileUrl,
          };
        }
        return config;
      }) || [];

    const isMailChimpAB = !!state.campaignEmail?.mailChimpABConfig;
    const isEnBoxAB = !!state.campaignEmail?.enBoxABConfig;

    return {
      ...state,
      campaignEmail: {
        ...state.campaignEmail,
        emailLocaleConfigs: updatedConfigs,

        mailChimpABConfig: isMailChimpAB
          ? {
              ...state.campaignEmail!.mailChimpABConfig!,
              emailTemplatePath: fileUrl,
              emailTemplatePathAdvance: fileUrl,
            }
          : state.campaignEmail?.mailChimpABConfig,

        enBoxABConfig: isEnBoxAB
          ? {
              ...state.campaignEmail!.enBoxABConfig!,
              emailTemplatePath: fileUrl,
              emailTemplatePathAdvance: fileUrl,
            }
          : state.campaignEmail?.enBoxABConfig,
      } as CampaignEmail,
    };
  }),
  on(aws_sesSendersSuccess, (state, { aws_sesSenders }) => ({
    ...state,
    senderEmailAddresses: aws_sesSenders.senderEmailAddresses,
    senderNames: aws_sesSenders.senderNames,
  })),
  on(updateCampaignSMS, (state, { changes }) => ({
    ...state,
    campaignSms: {
      ...state.campaignSms,
      ...changes,
    },
  })),
  on(updateCampaignViber, (state, { changes }) => ({
    ...state,
    campaignViber: {
      ...state.campaignViber,
      ...changes,
    },
  })),
  on(updateCampaignEmail, (state, { changes }) => ({
    ...state,
    campaignEmail: {
      ...state.campaignEmail,
      ...changes,
    },
  })),
  on(updateCampaignAdhocPoints, (state, { changes }) => ({
    ...state,
    campaignAdHocPoint: {
      ...state.campaignAdHocPoint,
      ...changes,
    },
  })),
  on(updateCampaignAdHocListAction, (state, { changes }) => ({
    ...state,
    campaignAdHocListAction: {
      ...state.campaignAdHocListAction,
      ...changes,
    },
  })),
  on(updatePushNotificationConfig, (state, { payload }) => ({
    ...state,
    campaignPushNotification: {
      ...state.campaignPushNotification!,
      ...payload,
    },
  })),
  on(fetchPushNotificationAccountsInit, (state) => ({
    ...state,
    pushNotificationAccounts: [],
  })),

  on(fetchPushNotificationAccountsSuccess, (state, { accounts }) => ({
    ...state,
    pushNotificationAccounts: accounts,
  })),
  on(fetchPushNotificationAccountsFailure, (state) => ({
    ...state,
    pushNotificationAccounts: [],
  })),
  on(updateInAppMessageConfig, (state, { payload }) => ({
    ...state,
    campaignInAppMessage: {
      ...state.campaignInAppMessage,
      ...payload,
    },
  })),
  on(toggleInAppLanguage, (state, { languageCode, isChecked }) => {
    let updatedLanguages = [...state.selectedInAppLanguages];

    if (isChecked && !updatedLanguages.includes(languageCode)) {
      updatedLanguages.push(languageCode);
    } else if (!isChecked) {
      updatedLanguages = updatedLanguages.filter((code) => code !== languageCode);
    }

    return {
      ...state,
      selectedInAppLanguages: updatedLanguages,
    };
  }),
  on(UpdateCoupon, (state, { coupon }) => {
    const updatedCoupon = { ...state.campaignCoupon, ...coupon };

    if (coupon.expirationType) {
      updatedCoupon.couponDurationDays =
        coupon.expirationType === 'durDays' ? updatedCoupon.couponDurationDays : null;
      updatedCoupon.couponValidFrom =
        coupon.expirationType === 'valUnFr' ? updatedCoupon.couponValidFrom : null;
      updatedCoupon.couponValidUntil =
        coupon.expirationType === 'valUnFr' ? updatedCoupon.couponValidUntil : null;
    }

    return {
      ...state,
      campaignCoupon: updatedCoupon,
    };
  }),
  on(ToggleCouponAction, (state, { actionField }) => {
    const resetActions = {
      useAvailableCoupon: false,
      useAvailableCouponForMember: false,
      couponReminder: false,
      customCouponAction: null,
    };

    const currentValue = state.campaignCoupon[actionField as keyof typeof state.campaignCoupon];
    const isAlreadyActive =
      actionField === 'customCouponAction' ? currentValue !== null : currentValue === true;

    if (isAlreadyActive) {
      return {
        ...state,
        campaignCoupon: {
          ...state.campaignCoupon,
          ...resetActions,
        },
      };
    }

    const newValue =
      actionField === 'customCouponAction' ? { type: null, customGenerationKey: null } : true;

    return {
      ...state,
      campaignCoupon: {
        ...state.campaignCoupon,
        ...resetActions,
        [actionField]: newValue,
      },
    };
  }),
  on(UpdateCustomCouponAction, (state, { update }) => ({
    ...state,
    campaignCoupon: {
      ...state.campaignCoupon,
      customCouponAction: state.campaignCoupon.customCouponAction
        ? { ...state.campaignCoupon.customCouponAction, ...update }
        : null,
    },
  })),
  on(getCouponSetsSuccess, (state, { couponSets }) => ({
    ...state,
    couponSets,
  })),
  on(getCouponActionsSuccess, (state, { couponActions }) => ({
    ...state,
    couponActions,
  })),
  on(FilterCouponSets, (state, { filter }) => ({
    ...state,
    couponSetFilter: filter,
  })),
  on(getPointSourcesSuccess, (state, { pointSources }) => ({
    ...state,
    pointSources,
  })),
  on(updateCampaignReport, (state, { campaignReport }) => ({
    ...state,
    campaignReport,
  })),
  on(getTagsSuccess, (state, { tags }) => ({
    ...state,
    tags,
  })),
  on(updateCampaignTag, (state, { changes }) => ({
    ...state,
    campaignTag: {
      ...state.campaignTag,
      ...changes,
    },
  })),
  on(getFlowsSuccess, (state, { flows }) => ({
    ...state,
    flows,
  })),
  on(updateCampaignFlow, (state, { flowId }) => ({
    ...state,
    campaignFlow: { flowId },
  })),
  on(updateCampaignAttribute, (state, { changes }) => ({
    ...state,
    campaignAttribute: {
      ...state.campaignAttribute,
      ...changes,
    } as CampaignAttribute,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
  on(showAdhocList, (state, { actionType }) => {
    if (actionType === 'VIBER') {
      return {
        ...state,
        selectedActionType: actionType,
        campaignViber: {
          ...state.campaignViber,
          showViberAdhocList: true,
        },
      };
    } else if (actionType === 'FALLBACK_SMS') {
      return {
        ...state,
        selectedActionType: actionType,
        campaignViber: {
          ...state.campaignViber,
          fallBackSms: {
            ...state.campaignViber?.fallBackSms,
            showFallbackSmsAdhocList: true,
          },
        },
      };
    } else if (actionType === 'SMS') {
      return {
        ...state,
        selectedActionType: actionType,
        campaignSms: {
          ...state.campaignSms,
          showSmsAdhocList: true,
        },
      };
    }
    return {
      ...state,
      selectedActionType: actionType,
    };
  }),
  on(fetchAdhocListDataSuccess, (state, { data }) => ({
    ...state,
    adhocListData: data,
  })),
  on(testCampaignAdhocListItemChanged, (state, { testAdhocListItem, actionType }) => {
    if (actionType === 'VIBER') {
      return {
        ...state,
        selectedTestViberCampaignAdhocList: testAdhocListItem,
        enableViberActionButtons: true,
      };
    } else if (actionType === 'FALLBACK_SMS') {
      return {
        ...state,
        selectedTestFallbackSmsCampaignAdhocList: testAdhocListItem,
        enableFallbackSmsActionButtons: true,
      };
    } else if (actionType === 'SMS') {
      return {
        ...state,
        selectedTestSmsCampaignAdhocList: testAdhocListItem,
        enableSmsActionButtons: true,
      };
    }

    return {
      ...state,
      selectedTestViberCampaignAdhocList: null,
      selectedTestFallbackSmsCampaignAdhocList: null,
      selectedTestSmsCampaignAdhocList: null,
    };
  }),
);
